// tasks
export const GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS';
export const GET_TASKS_FAILURE = 'GET_TASKS_FAILURE';
export const GET_TASKS_REQUEST = 'GET_TASKS_REQUEST';
export const CLEAR_TASKS = 'CLEAR_TASKS';

// task
export const SELECT_TASK = 'SELECT_TASK';
export const CLEAR_SELECTED_TASK = 'CLEAR_SELECTED_TASK';

// pagination
export const SET_TASKS_SEARCH = 'SET_TASKS_SEARCH';
export const SET_TASKS_PAGE_SIZE = 'SET_TASKS_PAGE_SIZE';
export const NEXT_TASKS_PAGE = 'NEXT_TASKS_PAGE';
export const PREV_TASKS_PAGE = 'PREV_TASKS_PAGE';
